<template>
<div class='gBorder'>

  <el-button class='gSgLeftBtn'  :disabled="sNum<=0"  @click='mulDelAppPush()' style=''>{{$t('app_mulUnbind')}} ({{sNum}})</el-button>

  <el-table
    :data="tableData"
    border
    class='gTopMg'
    style="width: 100%"
    show-header='false'
    @selection-change="handleSelectionChange"
    v-loading="loading">
    <el-table-column

      type="selection"
      align='center'
      width="55">
    </el-table-column>
    <el-table-column
      prop="appName"
      :label="$t('terminal.appList.label_name')">
    </el-table-column>
    <el-table-column
      prop="packageName"
      :label="$t('app_package')">
    </el-table-column>
    <el-table-column
      prop="type"
      :formatter="formatStatus"
      :label="$t('terminal.appList.label_type')">
    </el-table-column>
    <el-table-column
      prop="appVersion"
      :label="$t('terminal.appList.label_version')">
    </el-table-column>
    <el-table-column
      prop="versionCode"
      :label="$t('app_verTag')">
    </el-table-column>
    <el-table-column
      prop="createTime"
      :label="$t('terminal.appList.label_time')">
    </el-table-column>
    <el-table-column width='123' align='center' :label="$t('lin_global.ope')">
      <template slot-scope="scope">
        <!-- <el-button
          size="small"
          v-if="scope.row.ifBind"
          type='text'
          @click="unbund(scope.row)">{{$t('lin_btn.xiezai')}}</el-button> -->

          <el-tooltip class="item" effect="dark" :content="$t('lin_btn.xiezai')" placement="top" v-if="scope.row.ifBind">
            <el-button type='text' @click='unbund(scope.row)'><i class="fa fa-times-rectangle" style="color:#FF4949"></i></el-button>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :content="$t('app_clupappdt')" placement="top" >
            <el-button v-show='scope.row.type == 0' type='text' @click='clearAppData(scope.row)'><i class="fa fa-eraser" style=""></i></el-button>
          </el-tooltip>

          <!-- <el-tooltip class="item" effect="dark" :content="$t('app_appautrn')" placement="top" >
            <el-button  type='text' @click='setAutoLc(scope.row)'><i class="fa fa-font" style=""></i></el-button>
          </el-tooltip> -->

      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  export default {
    data() {
      return {
        sNum:0,
        list: [],
        terminalID: this.$route.params.id,
        terNo: '',
        tableData: [],
        loading: true,
      }
    },
    created() {
      this.terNo = this.$getWObj().tdToList
      this.getList()
    },
    methods:{
      setAutoLc (row) {
        this.loading = true

        var packageName = row.packageName
        var terminalNo = this.terNo

        this.$autoLaunchApp(terminalNo, packageName, (res) => {
          this.loading = false
          if (res.status === 200) {
            this.$message.success(res.message)
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      clearAppData (row) {
        this.$confirm(this.$t('app_isclupappdt') + '?', this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = true
          var type = ''
          var packageName = row.packageName
          var terminalNo = this.terNo
          this.$dvcmd('QCYYSJ', type, packageName, terminalNo, (res) => {

            this.loading = false

            if (res.status === 200) {
              this.$message.success(res.message)
              // this.getList()
            } else {
              this.$message.error(res.message)
            }

          }, (err) => {
            this.loading = false
          })
        }).catch(() => {
        })
      },
      mulDelAppPush () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           console.log(this.list)

           var isPass = true
           this.list.forEach((vl) => {
             if(vl.type == 1) {
               isPass = false
               return
             }
           })

           if (!isPass) {
             this.$message(this.$t('app_cannotwithsysapp'))
             return
           }


          console.log('ll', this.list)



            var pkg = ''
            var vers = ''
            this.list.forEach((vl) => {
              pkg += vl.packageName + ','
              vers += vl.appVersion + ','
            })
            pkg = pkg.substring(0, pkg.length - 1)
            vers = vers.substring(0, vers.length - 1)

            var _this = this
            this.$unbind(this.terNo, vers, pkg, (res) => {
              this.loading = 0
              this.$message(res.message)
              if (res.status === 200) {

                setTimeout(() => {
                  _this.getList()
                }, 1500)
              }
            }, () => {
              this.loading = 0
            })

        }, '')
      },
      handleSelectionChange (list) {

        this.sNum = list.length
        this.list = list
      },
      formatStatus:function(row,column){
        return row.type == 0 ? this.$t('terminal.appList.format_status1'):row.type == 1 ? this.$t('terminal.appList.format_status2'):'';
      },
      unbund:function(row){
        // un

        //var params = {application_id:b,terminal_id:a,packageName:c};
        this.$confirm(this.$t('terminal.appList.tips1') + '?', this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$unbind(row.terminalNo, row.appVersion, row.packageName, (res) => {
            this.loading = false

            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }

          }, (err) => {
            this.loading = false
          })
        }).catch(() => {

        })

      },
      getList:function(){
        var params = {page:1,rows:10000,terminal_id:this.terminalID};
        axios.post(`${baseurl}/terminal_app/bindList.do`,params).then(res=>{
            //console.log("打印应用列表");
            //console.log(res.data);
            if(res.data.status == 200){
              this.tableData = res.data.data;
              this.loading = false;
              for(var i = 0;i<res.data.data.length;i++){
                if(res.data.data[i].type == 0){
                  res.data.data[i]['ifBind'] = true;
                }else if(res.data.data[i].type == 1){
                  res.data.data[i]['ifBind'] = false;
                }else{
                  return false
                }
              }
            }else{

              this.$message(res.data.message)
              this.loading = false;
            }

        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// appList.vue?68c01c66